import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const commonService = inject(CommonService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        let redirect_url = router.url;
        if (redirect_url != '/login')
          sessionStorage.setItem('redirect_url', router.url);
        router.navigate(['/login']);
      }
      if (error.status === 403) {
        commonService.showErrorAlert(
          "Vous n'avez pas les droits nécessaires pour accéder à cette ressource.",
          'Accès refusé',
        );
      }
      return throwError(() => error);
    }),
  );
};
